<section class="list-items">
    @for (item of [0, 1, 2]; track $index) {
        <div
            class="list-item"
        >
            <div class="list-item__image">
                <p-skeleton class="item-image" width="100%" height="100%"/>
            </div>
            <div class="list-item__text">
                <p-skeleton width="80%" height="1.25rem"/>
                <p-skeleton width="60%" height=".9rem" class="mt-xs"/>
                <p-skeleton width="60%" height=".9rem"/>
                <p-skeleton width="90%" height=".9rem" class="mt-m"/>
            </div>
        </div>
    }
</section>
